// src/api/deleteCard.tsx
import { getAuth } from "firebase/auth";
import { apiBase } from "../../firebaseConfig";

export interface DeleteCardPayload {
  storeID: string;
  cardDocId: string;
}
export interface DeleteCardResponse {
  code: "cardDeleted" | "cardNotFound";
}

export async function deleteCard(
  payload: DeleteCardPayload
): Promise<DeleteCardResponse> {
  const idToken = await getAuth().currentUser?.getIdToken(true);
  // Add / before deleteCard to ensure correct path
  const url = `${apiBase()}/deleteCard`;

  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    // Add detailed error information
    let errorMsg = `Delete failed with HTTP ${res.status}`;
    try {
      const errorBody = await res.json();
      errorMsg += ` - ${errorBody.error || "No additional error details"}`;
    } catch {
      // Fallback if response isn't JSON
    }
    throw new Error(errorMsg);
  }
  return (await res.json()) as DeleteCardResponse;
}
